import { render, staticRenderFns } from "./AdditionalDocuments.vue?vue&type=template&id=6cc77608&scoped=true&"
import script from "./AdditionalDocuments.vue?vue&type=script&lang=js&"
export * from "./AdditionalDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc77608",
  null
  
)

export default component.exports